import script from "./RuleSpecial.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleSpecial.vue?vue&type=script&setup=true&lang=js"

import "./RuleSpecial.vue?vue&type=style&index=0&id=708e5822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-708e5822"]])

export default __exports__